// TODO fix accessibility issues

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import { memo } from 'react';

import Icon from 'shopper/components/Icon';

import Image from 'components/Image';

import { noop } from 'lib/utils';

const LastCommentsListItemImage = ({
  description,
  image = null,
  thread = null,
  onClick = noop,
  ...rest
}) => {
  if (thread) {
    return (
      <a
        className="flex size-20 items-center justify-center bg-neutral-high-200 md:size-[100px]"
        onClick={onClick}
        {...rest}
      >
        <Icon
          className="size-[38px] text-neutral-high-400"
          name="messages"
          size={null}
        />
      </a>
    );
  }

  return (
    <a {...rest}>
      <Image
        alt={description}
        className="border border-neutral-high-400 object-cover dark:border-neutral-low-100 md:size-[100px]"
        height={80}
        src={image}
        width={80}
        onClick={onClick}
      />
    </a>
  );
};

LastCommentsListItemImage.propTypes = {
  image: PropTypes.string,
  thread: PropTypes.bool,
  onClick: PropTypes.func,
};

export default memo(LastCommentsListItemImage);
